import { Edge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/dist/types/types';

export type DragState =
  | { type: 'idle' }
  | { type: 'preview'; container: HTMLElement }
  | { type: 'is-dragging' }
  | { type: 'is-dragging-over'; closestEdge: Edge | null };

export const IDLE: DragState = { type: 'idle' };
